import { ToolStatusLine } from "./ToolStatusLine";

type Status = "pending" | "success" | "failed";

interface RenderParams {
  toolName: string;
  status: Status;
  personaName?: string | null;
  enableAnimation?: boolean;
}

export const renderToolStatusLine = ({
  toolName,
  status,
  personaName,
  enableAnimation = true,
}: RenderParams) => {
  const actor = personaName ?? "Adonis";

  const getCopy = () => {
    switch (toolName) {
      case "render_product_recommendations":
        return `${actor} ${
          status === "pending"
            ? "is preparing recommendations"
            : "recommended products"
        }`;
      case "get_package_details":
        return `${actor} ${
          status === "pending"
            ? "is looking for a treatment for you"
            : "found a treatment for you"
        }`;
      case "get_membership_details":
        return `${actor} ${
          status === "pending"
            ? "is searching for membership details"
            : "searched for membership details"
        }`;
      case "list_memberships":
        return `${actor} ${
          status === "pending"
            ? "is looking at the list of memberships"
            : "looked at the list of memberships"
        }`;
      case "list_available_discounts":
        return `${actor} ${
          status === "pending"
            ? "is looking at the list of discounts"
            : "looked at the list of discounts"
        }`;
      case "get_order_history":
        return `${actor} ${
          status === "pending"
            ? "is searching for your order history"
            : "searched for your order history"
        }`;
      default:
        return `${actor} ${toolName} ${
          status === "pending" ? "is searching" : "got results"
        }`;
    }
  };

  return (
    <ToolStatusLine
      toolName={getCopy()}
      toolId={toolName}
      status={status}
      enableAnimation={enableAnimation}
    />
  );
};
